/**
 * Selleasy "Product add-ons" widget: allow only one add-on to be selected.
 *
 * Selleasy has no setting to limit add-on selection to one product, so when a
 * shopper checks an add-on, uncheck every other checked add-on in the same
 * widget.
 *
 * Shoppers click Selleasy's own checkbox overlay (.lb-custom-checkbox), and
 * Selleasy then sets the real checkbox itself without firing a `change` event.
 * So this listens for clicks inside the widget, waits for Selleasy to update,
 * and compares which checkboxes are checked before and after. The other
 * checked boxes are unchecked with .click() (not .checked = false) so
 * Selleasy's own handlers run and its selection stays in sync.
 */
(function () {
  var syncing = false;

  function checkedIndexes(widget) {
    var indexes = [];
    widget.querySelectorAll('.lb-card-checkbox').forEach(function (checkbox, index) {
      if (checkbox.checked) indexes.push(index);
    });
    return indexes;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (syncing || !(event.target instanceof Element)) return;

      var widget = event.target.closest('.lb-addon-cont');
      if (!widget) return;

      var before = checkedIndexes(widget);

      setTimeout(function () {
        var after = checkedIndexes(widget);
        var added = after.filter(function (index) {
          return before.indexOf(index) === -1;
        });
        if (!added.length) return;

        var keep = added[added.length - 1];
        var checkboxes = widget.querySelectorAll('.lb-card-checkbox');

        syncing = true;
        after.forEach(function (index) {
          if (index !== keep && checkboxes[index]) checkboxes[index].click();
        });
        syncing = false;
      }, 50);
    },
    true
  );
})();
